<div ibMmbCollapse [collapsed]="collapsed" [closeOnResize]="false" collapseTrigger="digitalMenuTrigger"
    collapseContainer="digitalMenuContainer" (collapseClosedEvent)="closeModal()">
    <!-- Card Digital Menu -->
    <div class="ib-pre-selection__gastrobar-options-container"  [ngClass]="{ 'ib-pre-selection__gastrobar-options-container-mob': isMobile }">
        <div class="ib-pre-selection__gastrobar-options-img img-content" [ngClass]="{'ib-pre-selection__gastrobar-options-options-img-mob': isMobile }">
            <img *ngIf="!isMobile" [src]="imgRoute" alt="Opción gastronómica" />
            <img *ngIf="isMobile" [src]="imgRouteMobile" alt="Opción gastronómica" class='ib-pre-selection__gastrobar-options-img-mob'/>
        </div>
        <div class="ib-pre-selection__gastrobar-options-content content-container">
            <h4 class="ib-pre-selection__gastrobar-options-content--title ib-heading
              ib-heading--type-3 u-color-primary">
                {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_TITLE' | translate}}
            </h4>
            <p class="ib-pre-selection__gastrobar-options-content--text ib-text">
                {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_TXT_1' | translate}}
                <span class="ib-text--bold">
                    {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_TXT_2' | translate }}
                </span>
                {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_TXT_3' | translate}}
            </p>
            <div class="ib-pre-selection__gastrobar-options-content--controls">
                <button (click)="showDigitalMenu()" class="ib-pre-selection__gastrobar-options-content--button
                    ib-button ib-button--small ib-text--bold xu-mt-small">
                    {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_BUTTON' | translate}}
                </button>
                <span #triggerDM digitalMenuTrigger class="hide-accessible"></span>
            </div>
        </div>
    </div>
    <!-- End Card Digital Menu -->

    <!-- Digital Menu Modal Content -->
    <div class="collapse-container" digitalMenuContainer>
        <div *ngIf="digitalMenuData" class="ib-modal-pre-selection-menu-on-board">
            <header class="ib-special-modal__header">
                <div class="ib-special-modal__header--top ib-special-separator ib-special-separator--bottom">
                    <div class="ib-special-modal__header--top-info">
                        <h2 class="ib-heading ib-heading--type-2 ib-special-modal__header-title ">
                            <button class="ib-digital-menu ib-digital-menu__button">
                                <span class="icon-flecha_1_izquierda icon--red" (click)="resetDigitalMenuData()"
                                    digitalMenuTrigger></span>
                            </button>
                            {{'MODAL_DIGITAL_MENU_TITLE' | translate}}
                        </h2>
                        <div class="ib-special-modal__header-info">
                            <p class="ib-special-modal__header-info--top">
                                <span class="ib-text hidden-xs">{{'GENERAL_OUTBOUND_TEXT' | translate}}</span>
                                <span
                                    class="ib-text hidden-xs">{{digitalMenuData.flight.departureAirport.cityName}}</span>
                                <span
                                    class="ib-text ib-iata-text ib-modal-pre-selection-menu-on-board__hidden--lg">{{digitalMenuData.flight.departureAirport.cityCode}}</span>
                                <span class="ib-text">-</span>
                                <span
                                    class="ib-text hidden-xs">{{digitalMenuData.flight.arrivalAirport.cityName}}</span>
                                <span
                                    class="ib-text ib-iata-text ib-modal-pre-selection-menu-on-board__hidden--lg">{{digitalMenuData.flight.arrivalAirport.cityCode}}</span>
                            </p>

                            <p *ngIf="flightSelected" class="ib-special-modal__header-info--bottom">
                                <span class="ib-text hidden-xs hidden-sm hidden-md">
                                    {{flightSelected.departureDateTime}} -
                                    {{flightSelected.cabin.bookingClass}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="ib-modals__header-settings">
                        <button (click)="closeAll()" type="button"
                            class="ib-digital-menu ib-digital-menu__button ib-digital-menu__button-action icon-cerrar">
                            <span class="hide-accessible ib-base__page-icon__txt">
                                {{'GENERIC_MODAL_ACCESSIBLE_CLOSE' | translate}}
                            </span>
                        </button>
                    </div>

                </div>
            </header>
            <section class="ib-special-modal__container ib-special-modal__content--grey">
                <p class="ib-text ib-radio__text--black">
                    {{'MODAL_DIGITAL_MENU_DESCRIPTION_TXT_1' | translate}}
                    <a (click)="openSpecialMeals()" class="ib-link ib-link--important ib-link--underline">
                        {{'MODAL_DIGITAL_MENU_DESCRIPTION_TXT_2' | translate}}</a>
                    {{'MODAL_DIGITAL_MENU_DESCRIPTION_TXT_3' | translate}}
                </p>


                <div class="ib-digital-menu__container--title-result-download
                    ib-flex ib-flex--align-center ib-flex--flex-end u-mt-medium u-mb-small">
                    <!-- Download PDF -->
                    <div *ngIf="!loadingPDF.loading && !this.loadingPDF.error" class="ib-flex ib-flex--align-center">
                        <span class="icon-descargar ib-text--color-important"></span>
                        <a href="javascript:void(0)" class="ib-link" ibFocusin (click)="dowloadMenuPDF()"
                            [attr.aria-label]="'ACCESSIBILITY_DOWNLOAD_PDF_MENU' | translate">
                            {{'DIGITAL_MENU_DOWNLOAD_MENU' | translate}}
                        </a>
                    </div>
                    <!-- Loading animation -->
                    <div *ngIf="loadingPDF.loading && !this.loadingPDF.error"
                        class="ib-digital-menu__download-spinner ib-date-carousel__price-loading--inline">
                        <div class="ib-date-carousel__price-loading--content">
                            <div class="ib-date-carousel__price-loading--spinner">
                                <div></div>
                                <div></div>
                            </div>
                            <span class="ib-date-carousel__price-loading--text">
                                {{'MMB_GASTRONOMIC_PROPOSAL_DIGITAL_MENU_LOADING_PDF' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <ib-digital-menu-content [categories]="digitalMenuData.cabins[0].categories"
                        [disclaimer]="digitalMenuData.disclaimer" [expressMenu]="digitalMenuData.expressMenu">
                    </ib-digital-menu-content>
                </div>
            </section>
            <!-- Footer Modal -->
            <div class="ib-special-modal__footer-dm">
                <div class="ib-content-buttons">
                    <div class="ib-content-buttons__content-left">
                        <button (click)="showNextFlightButton ? goToNextFligthOptions(): closeModal()"
                            class="ib-button ib-button--w-medium" type="button">
                            {{showNextFlightButton ? ('MMB_GASTRONOMIC_NEXT_FLIGHT_BUTTON' | translate) :
                            ('MMB_GASTRONOMIC_FINISH_BUTTON' | translate) }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Digital Menu Modal Content -->
</div>
